export default `---
slug: ireland
country: Ireland
countryCode: IRL
continent: Europe
year: 2022
title: "Thirty Euros, One World Cup Final, and Too Much Guinness"
description: "A last-minute Ryanair weekend in Dublin — free accommodation courtesy of a friend at Google, Argentina lifting the trophy, and an unreasonable number of pints."
thumbnail: /images/travels/IRL/cover.jpg
---

Some trips are planned for months. Some are born on a Wednesday morning at 7am.

## The €30 Ticket

I got a message from my friend Napoleon — Napi — on a Wednesday. Something like: <i>"Hey, just found Ryanair tickets Amsterdam to Dublin, €30 each way. You in?"</i>

I was in.

We left on Saturday. Back to the Netherlands by Monday. Technically a weekend, if you're generous with the definition. The whole thing cost almost nothing, because a mutual friend of ours — Francesco — had moved to Dublin and was working at <b>Google</b>. So we texted him, he said come stay at mine, and suddenly we had free accommodation too.

<i>Cheap flights. Free bed. Good company. December in Dublin.</i>

The weather was genuinely awful. This is not a surprise. December in Ireland is exactly what you'd expect it to be: grey, wet, wind with opinions. But you adapt.

## Dublin in December

We did the tourist round: the old city, the cobbled pub streets, <a href="https://www.tcd.ie/visitors/book-of-kells/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Trinity College</a> with its famous library, the parks. December meant it got dark embarrassingly early — you'd be standing somewhere scenic in what felt like mid-afternoon, thinking about your day, and suddenly it was 4pm and pitch black.

So we did what you do in Dublin when the sun disappears at half past four: <b>we went to a pub.</b>

This became the rhythm of the weekend. Walk somewhere, look at something, get cold and wet, find a pub, order Guinness. Repeat. We drank an amount of Guinness over those few days that I'm not entirely comfortable disclosing. It was a lot. Guinness in Dublin hits differently than Guinness anywhere else — proper pour, perfect temperature, served by someone who looks slightly judgemental about how you're holding your glass.

## The Final

The weekend coincided with the <b>FIFA World Cup final</b> — Qatar 2022, Argentina vs France. We watched it in a pub, surrounded by people who had complicated feelings about it, given that neither team was Ireland. The atmosphere was electric regardless.

Argentina won on penalties. <i>Messi lifted the trophy.</i> The pub erupted. We raised our Guinnesses and absorbed the fact that we were watching one of the greatest World Cup finals in history from a pub in Dublin, on a trip that had been decided four days earlier based on a cheap Ryanair alert.

## The Google Campus

On Monday morning, before our flight, Francesco took us to the <b>Google Dublin offices</b>. A proper campus — huge, polished, the kind of tech company headquarters where every detail has been optimised for either productivity or the impression of it. It was interesting to see. Francesco seemed comfortable there, which made sense.

We then went to the airport and flew back to Amsterdam.

We didn't do the <a href="https://www.guinness-storehouse.com/en" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Guinness Storehouse</a>. We didn't do the whiskey distillery, which everyone who'd been said was fantastic. We didn't see the Irish countryside, the Cliffs of Moher, or any of the things that probably make Ireland what Ireland actually is.

<i>We just drank Guinness in pubs and watched Argentina win the World Cup.</i>

I know there's a lot more to see. I'd like to go back and do it properly — the landscape, the coast, the slower version of it. But for a weekend born from a 7am WhatsApp message and a €30 Ryanair deal, it left a very good impression.
`;
